import React from "react";
import Home from "./Home";
import NavBar from "./NavBar";

const Main = () => {
  return (
    <>
      <NavBar />

      <div>
        <Home />
      </div>
    </>
  );
};

export default Main;
